/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Volo_Abp_Account_RegisterDto } from '../models/Volo_Abp_Account_RegisterDto';
import type { Volo_Abp_Account_ResetPasswordDto } from '../models/Volo_Abp_Account_ResetPasswordDto';
import type { Volo_Abp_Account_SendPasswordResetCodeDto } from '../models/Volo_Abp_Account_SendPasswordResetCodeDto';
import type { Volo_Abp_Account_VerifyPasswordResetTokenInput } from '../models/Volo_Abp_Account_VerifyPasswordResetTokenInput';
import type { Volo_Abp_Identity_IdentityUserDto } from '../models/Volo_Abp_Identity_IdentityUserDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AccountService {

    /**
     * @param requestBody
     * @returns Volo_Abp_Identity_IdentityUserDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAccountRegister(
        requestBody?: Volo_Abp_Account_RegisterDto,
    ): CancelablePromise<Volo_Abp_Identity_IdentityUserDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/account/register',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAccountSendPasswordResetCode(
        requestBody?: Volo_Abp_Account_SendPasswordResetCodeDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/account/send-password-reset-code',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAccountVerifyPasswordResetToken(
        requestBody?: Volo_Abp_Account_VerifyPasswordResetTokenInput,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/account/verify-password-reset-token',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAccountResetPassword(
        requestBody?: Volo_Abp_Account_ResetPasswordDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/account/reset-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
